const PhotoWithPopup = {};

export default PhotoWithPopup